import React, { useEffect, useRef, useState } from "react";
import recoSuggestions from "./recoSuggestions";
import RecoModal from "./RecoModal";

const MAX_CHARS = 200;

const Sremarque = ({
  remarque,
  color,
  changeCarnetRemarque,
  changeModuleRemarque,
  general,
  unitInedx,
}) => {
  const [open, setOpen] = useState(false);
  const [charCount, setCharCount] = useState((remarque || "").length);
  const [modalOpen, setModalOpen] = useState(false);
  const initializedRef = useRef(false);

  useEffect(() => {
    if (initializedRef.current) return;
    if (remarque === undefined || remarque === null) return;
    initializedRef.current = true;
    if (remarque.trim() !== "" && remarque.trim() !== ".") {
      setOpen(true);
    }
  }, [remarque]);

  const suggestions = recoSuggestions["_comportement"] || [];

  return (
    <div style={{ padding: "4px 0" }}>
      <button
        type="button"
        className="remark-toggle"
        onClick={() => setOpen((v) => !v)}
        title={open ? "Masquer la recommandation" : "Afficher la recommandation"}
      >
        <span className="chevron">{open ? "▴" : "▾"}</span>
        <span>Comportement et assiduité</span>
      </button>
      {open && (
        <div style={{ marginTop: 6 }}>
          <label style={{
            fontSize: 12,
            color: "#92400e",
            fontWeight: 500,
            display: "block",
            borderBottom: `1px solid #fef3c7`,
            paddingBottom: 3,
            marginBottom: 4,
          }}>
            Comportement et assiduité :
          </label>
          <textarea
            value={remarque || ""}
            className="form-control"
            maxLength={MAX_CHARS}
            onChange={(e) => {
              setCharCount(e.target.value.length);
              general
                ? changeCarnetRemarque(e.target.value)
                : changeModuleRemarque(unitInedx, e.target.value);
            }}
            placeholder="................................."
            style={{ minWidth: "100%", maxHeight: "150px", fontSize: 13 }}
          />
          <div className={`remark-counter${charCount >= MAX_CHARS ? " danger" : charCount >= MAX_CHARS * 0.7 ? " warning" : ""}`}>
            {charCount} / {MAX_CHARS}
          </div>
          {suggestions.length > 0 && (
            <div style={{ marginTop: 8 }}>
              <div style={{ fontSize: 11, color: "#92400e", fontWeight: 500, marginBottom: 4, display: "flex", alignItems: "center", gap: 6 }}>
                <span>💡 Suggestions fréquentes</span>
                {suggestions.length > 4 && (
                  <button
                    type="button"
                    onClick={() => setModalOpen(true)}
                    style={{ background: "none", border: "none", cursor: "pointer", color: "#2563eb", fontSize: 13, padding: 0, fontWeight: 600, textDecoration: "underline", marginLeft: 8 }}
                  >
                    Voir tout ({suggestions.length})
                  </button>
                )}
              </div>
              <div style={{ display: "flex", flexWrap: "wrap", gap: 4 }}>
                {suggestions.slice(0, 4).map((s, i) => (
                  <button
                    key={i}
                    type="button"
                    dir={/[؀-ۿ]/.test(s.text.charAt(0)) ? "rtl" : "ltr"}
                    onClick={() => {
                      changeCarnetRemarque(s.text);
                      setCharCount(s.text.length);
                    }}
                    style={{
                      display: "inline-flex",
                      alignItems: "center",
                      gap: 4,
                      padding: "3px 8px",
                      fontSize: 13,
                      fontWeight: 500,
                      background: "white",
                      border: "1px solid #d1d5db",
                      borderRadius: 12,
                      cursor: "pointer",
                      color: "#1f2937",
                      lineHeight: 1.4,
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.borderColor = "#fbbf24";
                      e.currentTarget.style.background = "#fef9c3";
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.borderColor = "#d1d5db";
                      e.currentTarget.style.background = "white";
                    }}
                  >
                    <span>{s.text}</span>
                    <span style={{ color: "#9ca3af", fontSize: 10 }}>· {s.freq}</span>
                  </button>
                ))}
              </div>
            </div>
          )}
        </div>
      )}
      {modalOpen && (
        <RecoModal
          suggestions={suggestions}
          onSelect={(text) => { changeCarnetRemarque(text); setCharCount(text.length); setModalOpen(false); }}
          onClose={() => setModalOpen(false)}
        />
      )}
    </div>
  );
};

export default Sremarque;
